export default `
query zipCodeLookup($gameId: ID!, $zipCode: String!, $houseNumber: Int!, $houseNumberAddition: String) {
    zipCodeLookup(
        input: {
            gameId: $gameId
            zipCode: $zipCode
            houseNumber: $houseNumber
            houseNumberAddition: $houseNumberAddition
        }
    ) {
        ok
        result {
            street
            city
        }
        error
    }
}
`;
